import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../../../environments/environment';
import {Project} from '../../../../../shared/classes/project/project';

@Component({
  selector: 'app-project-information',
  templateUrl: './project-information.component.html',
  styleUrls: ['./project-information.component.css']
})
export class ProjectInformationComponent implements OnInit {

  @Input('projectForm') projectForm: FormGroup;
  @Input('readOnly') readOnly: boolean;
  @Input() disableEditionButton: boolean;
  @Input('project') project: Project;

  constructor(private translate: TranslateService) {
  }

  ngOnInit() {
  }
  public get archive() {
    return this.projectForm.get('archive');
  }


  public get name() {
    return this.projectForm.get('name');
  }

  public getErrorMessageName(): string {

    if (this.name.errors.required) {
      return this.translate.instant('VALUE_FORM_REQUIRED');
    }

    if (this.name.errors.minlength) {
      return this.translate.instant('VALUE_USER_NAME_TOO_SHORT');
    }

    if (this.name.errors.maxlength) {
      return this.translate.instant('VALUE_USER_NAME_TOO_LONG_30');
    }

    return '';
  }

  public get code() {
    return this.projectForm.get('code');
  }

  public getErrorMessageCode(): string {

    if (this.code.errors.required) {
      return this.translate.instant('VALUE_FORM_REQUIRED');
    }

    if (this.code.errors.minlength) {
      return this.translate.instant('VALUE_USER_NAME_TOO_SHORT');
    }

    if (this.code.errors.maxlength) {
      return this.translate.instant('VALUE_USER_NAME_TOO_LONG');
    }

    return '';
  }


  public get description() {
    return this.projectForm.get('description');
  }

  public getErrorMessageDescription(): string {

    if (this.description.errors.maxlength) {
      return this.translate.instant('VALUE_USER_DESCRIPTION_TOO_LONG');
    }

    return '';

  }

  public get document_url() {
    return this.projectForm.get('description');
  }

  public getErrorMessageDocumentUrl(): string {

    if (this.document_url.errors.maxlength) {
      return this.translate.instant('VALUE_USER_DESCRIPTION_TOO_LONG');
    }

    return '';

  }

  public get start_date() {
    return this.projectForm.get('start_date');
  }

  public getErrorMessageStartDate(): string {
    return this.start_date.errors.required ? this.translate.instant('VALUE_FORM_REQUIRED') : '';
  }


  public get end_date() {
    return this.projectForm.get('end_date');
  }

  public getErrorMessageEndDate(): string {
    return this.end_date.errors.required ? this.translate.instant('VALUE_FORM_REQUIRED') : '';
  }

  public dateStartIsLocked() {
    if (this.dateIsNotLockable()) {
      return this.readOnly;
    }
    return this.readOnly ? true : (Date.now() > Date.parse(this.projectForm.value.start_date)) && this.project.id;
  }

  public dateEndIsLocked() {
    if (this.dateIsNotLockable()) {
      return this.readOnly;
    }
    return this.readOnly ? true : (Date.now() > Date.parse(this.projectForm.value.end_date)) && this.project.id;
  }

  private dateIsNotLockable() {
    const level = this.project !== undefined ? (this.project.level !== undefined ? this.project.level : undefined) : undefined;
    return level ? !environment.levelProjectDateLocked.includes(level) : true;
  }

}
